import { History } from "lucide-react";
import { dictionaries } from "../lib/i18n";
import type { UiLang } from "../lib/types";

/**
 * Sier fra når opplysningene er hentet fra lagringen og ikke fra nå.
 *
 * Trafikkmeldinger, skredvarsel og ferjetider er ferske data, og en lagret plan
 * bærer dem fra den gang den ble laget. «Rv13 stengt» presentert som nå, når
 * meldingen er tre dager gammel, er ikke en unøyaktighet — det er en opplysning
 * man kan snu bilen på.
 *
 * Merkelappen skjuler ikke opplysningen. Siste kjente tilstand er fortsatt noe
 * verdt når man står uten dekning; den skal bare ikke leses som «nå».
 */
export function StaleNote({ savedAt, lang }: { savedAt: number; lang: UiLang }) {
  const t = dictionaries[lang];

  const when = new Date(savedAt).toLocaleString(lang === "no" ? "nb-NO" : "en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <p className="stale-note">
      <History size={12} />
      {t.staleData(when)}
    </p>
  );
}
